export const BASE_IMAGE_URL = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/'

export const TAB_ICON_DIMENSIONS = {height : 28 , width : 28}
export const INTEREST_CALCULATOR_URL = 'https://voltmoney.in/interest-calculator-iframe?isMobileView=true&showOnlyDownload=true';
export const TNC_LINK = 'https://staging.voltmoney.in/terms?showHeader=false'
export const PRIVACY_POLICY_LINK = 'https://staging.voltmoney.in/privacy?showHeader=false'


export enum STORE_KEY {
    FCM_TOKEN = 'fcm_token',
    LAST_DENIED_KEY = '@notification_last_denied',
    FCM_USER_ID = 'fcm_user_id',
}

export const ANDROID_PERMISSION = 'android.permission.POST_NOTIFICATIONS' as const;

export enum CreditApplicationType {
    CREDIT_AGAINST_SECURITIES_BORROWER = 'CREDIT_AGAINST_SECURITIES_BORROWER',
    CREDIT_AGAINST_SECURITIES_PARTNER = 'CREDIT_AGAINST_SECURITIES_PARTNER',
    CREDIT_MODIFICATION_AGAINST_SECURITIES = 'CREDIT_MODIFICATION_AGAINST_SECURITIES',
    CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES = 'CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES',
    CREDIT_RENEWAL_AGAINST_SECURITIES = 'CREDIT_RENEWAL_AGAINST_SECURITIES',
    CREDIT_LOAN_SERVICING_APPLICATION_AGAINST_SECURITIES = 'CREDIT_LOAN_SERVICING_APPLICATION_AGAINST_SECURITIES'
}

export enum CreditApplicationSubType {
    MANDATE_UPDATE = 'MANDATE_UPDATE',
}

export enum QUERY_PARAMS {
    START_NEW = 'startnew',
    PARTNER_PLATFORM = 'partnerplatform',
    PLATFORM = 'platform',
    USER = 'user',
    REF = 'ref',
    PRIMARY_COLOR = 'primaryColor',
    DASHBOARD_ACTIVE_ID = 'dashboardActiveId',
    UID = 'uid',
    RE_DIRECT = 'redirect',
    ROUTE = 'route',
    REFERRED_PARTNER = 'referredpartner',
    TARGET = 'target',
    MARKETING = 'marketing',
    IS_IFRAME = 'isIframe',
    IS_CHECK_LIMIT_MFC = 'isCheckLimitMFC',
    SHORT_LIVED_TOKEN= 't',
    PLJ = 'plj',
    PARTNER_ACCOUNT_ID = 'partnerAccountId',
    SOURCE = 'source',
    IS_FROM_PARTNER_APP = 'isFromPartnerApp',
    IS_CGTC = 'isCgtc',
    AMPLITUDE_DEVICE_ID = 'amplitudeDeviceId',
    UTM_SOURCE = 'utm_source',
    REQUEST_ID = 'request_id',
    PHONE_PE_FJ = 'Phonepe_fj',
    PLJ_SHORT_TOKEN = 'plkTK',
    SL = 'sl',
    CONTEXT = 'context',
    OC = 'oc',
    IS_CUSTOMER = 'isCustomer',
    CUSTOMER_SSO_TOKEN = 'customerSsoToken',
    SSO_TOKEN = 'ssoToken',
    APPLICATION_ID = 'applicationId'
}

export enum CONTEXT {
    PARTNER = 'PARTNER',
}

export const UPI_IDENTIFIERS = [
    "upi://",
    "gpay",
    "paytmmp",
    "phonepe",
    "credpay",
    "bhim",
    "ppe"
  ];

export enum CollateralType {
    SHARES = 'SHARES',
    MUTUAL_FUNDS = 'MUTUAL_FUNDS',
}

export enum CreditType {
    CREDIT_LINE_LAMF = 'CREDIT_LINE_LAMF',
    CREDIT_LINE_LAS = 'CREDIT_LINE_LAS',
}